<template>
    <div>
        <b-container fluid>
            <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
            <b-row no-gutters class="mt-3 mb-3">
                <b-col style="text-align: right">
                    <b-button
                        v-if="
                            this.$route.params.user_id
                                ? $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Account',
                                      'Edit',
                                      true
                                  )
                                : $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Account',
                                      'Create',
                                      true
                                  )
                        "
                        size="sm"
                        class="btn-action"
                        variant="info"
                        @click="submitAccountForm()"
                        >Save</b-button
                    >
                </b-col>
            </b-row>
            <b-card class="mb-1">
                <FormInput
                    :canEditFields="canEditFields"
                    :validateState="validateState"
                    :getErrorMessages="getErrorMessages"
                    :data="cms_user_obj"
                    :onChangeData="onChangeData"
                />
            </b-card>

            <b-card class="mb-1">
                <b-row class="mb-3">
                    <b-col class="col-3">
                        Permission Group
                    </b-col>
                    <b-col>
                        <b-form-select
                            size="sm"
                            v-model="permission_group_selected"
                            :options="permission_group_options"
                        />
                    </b-col>
                    <b-col class="col-2">
                        <b-button
                            size="sm"
                            class="btn-action"
                            variant="info"
                            @click="loadPermissionGroup()"
                            >Load</b-button
                        >
                    </b-col>
                </b-row>

                <b-table
                    responsive
                    small
                    outlined
                    striped
                    hover
                    :items="permissions"
                    :fields="permission_fields"
                >
                    <template v-slot:head(enable)="data">
                        <a href="#" @click="selectAll">
                            SelectAll
                        </a>
                        /
                        <a href="#" @click="unselectAll">
                            UnselectAll
                        </a>
                    </template>
                    <template v-slot:cell(enable)="data">
                        <b-form-checkbox
                            size="sm"
                            value="1"
                            unchecked-value="0"
                            plain
                            v-model="permission_obj[`${data.item.id}`].enable"
                            @change="onChangeCheckbox($event, data.item.id)"
                        ></b-form-checkbox>
                    </template>
                </b-table>
            </b-card>

            <b-row no-gutters class="mt-3">
                <b-col style="text-align: right">
                    <b-button
                        v-if="
                            this.$route.params.user_id
                                ? $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Account',
                                      'Edit',
                                      true
                                  )
                                : $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Account',
                                      'Create',
                                      true
                                  )
                        "
                        size="sm"
                        class="btn-action"
                        variant="info"
                        @click="submitAccountForm()"
                        >Save</b-button
                    >
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf, minLength } from "vuelidate/lib/validators";
import FormInput from "./common/FormInput";
import global_function from "../mixins/global_function";

let account_type_options = [
    {
        text: "Admin",
        value: "admin"
    },
    {
        text: "Client Admin",
        value: "client_admin"
    },
    {
        text: "Client User",
        value: "client_user"
    },
    {
        text: "Warehouse",
        value: "warehouse"
    },
    {
        text: "Vendor",
        value: "vendor"
    },
    {
        text: "Vendor Warehouse",
        value: "vendor_warehouse"
    },
    {
        text: "Client User",
        value: "client_user"
    },
    {
        text: "Route",
        value: "route"
    }
];

export default {
    name: "AccountForm",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "ERROR_MESSAGES"],
    mixins: [validationMixin, global_function],
    components: {
        FormInput
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: "Accounts",
                    to: { name: "cms_account" }
                },
                {
                    text: "Form",
                    active: true
                }
            ],

            loader: false,
            cms_user_obj: {},
            permissions: [],
            permission_obj: {},
            client_options: [],
            permission_group_selected: null,
            permission_fields: [
                {
                    key: "module",
                    label: "Module"
                },
                {
                    key: "sub_module",
                    label: "Sub Module"
                },
                {
                    key: "sys_function",
                    label: "Function"
                },
                {
                    key: "enable",
                    label: "Enabled"
                }
            ],
            permission_group_options: [],
            permission_groups: null,
        };
    },
    async created() {
        await this.getUser();
        await this.getUserPermission();
        await this.getPermissionGroup();
        await this.getClientProfile();
        // await this.getFookleiCategorys();

        if (this.$route.params.user_id) {
            this.edit_mode = true;
        }
        this.initialized = true;
    },
    validations: {
        cms_user_obj: {
            account_type: {
                required
            },
            username: {
                required
            },
            password: {
                required: requiredIf(function() {
                    return this.$route.params.user_id === undefined;
                }),
                minLength8: minLength(8)
            },
            new_password: {
                minLength8: minLength(8),
                password_not_match: function(val) {
                    return !val || val === this.cms_user_obj.confirm_password;
                }
            },
            confirm_password: {
                password_not_match: function(val) {
                    return !val || val === this.cms_user_obj.new_password;
                }
            },
            name: {
                required
            },
            phone: {},
            client_id: {}
        }
    },
    computed: {
        canEditFields: function() {
            return [
                {
                    type: "select",
                    options: account_type_options,
                    key: "account_type",
                    label: "* Account Type"
                },
                {
                    type: "text",
                    key: "username",
                    label: "* Username"
                },
                {
                    type: "password",
                    key: "password",
                    label: "* Password",
                    hidden: this.$route.params.user_id !== undefined
                },
                {
                    type: "password",
                    key: "new_password",
                    label: "New Password",
                    hidden: this.$route.params.user_id === undefined
                },
                {
                    type: "password",
                    key: "confirm_password",
                    label: "Confirm Password",
                    hidden: this.$route.params.user_id === undefined
                },
                {
                    type: "text",
                    key: "name",
                    label: "* Name"
                },
                {
                    type: "text",
                    key: "phone",
                    label: "Phone"
                },
                {
                    type: "select",
                    options: this.client_options,
                    key: "client_id",
                    label: "Client"
                },
            ];
        }
    },
    mounted() {},
    watch: {},
    methods: {
        async getUser() {
            if (!this.$route.params.user_id) {
                this.cms_user_obj = {};
                return;
            }
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_user_get.php",
                data: {
                    cms_user_id: this.$route.params.user_id,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.cms_user_obj = response.data.users[0];

            console.log(this.cms_user_obj);
        },

        async getUserPermission() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_permission_get.php",
                data: {
                    user_id: this.$route.params.user_id
                }
            });

            this.permissions = response.data.permissions;
            this.permissions.forEach(p => {
                this.permission_obj[p.id] = p;
            });

            console.log(this.permission_obj);
        },

        async getPermissionGroup() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_permission_group_get.php",
                data: {
                    offset: 0,
                    limit: 9999,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$route.params.user_id
                }
            });

            this.permission_groups = response.data.permission_groups;
            this.permission_group_options = response.data.permission_groups.map(pg => ({
                value: pg.id,
                text: pg.name
            }))

            console.log(this.permission_groups);
        },

        async getClientProfile() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_client_profile_get.php",
                data: {
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            let options = response.data.clients.map(c => ({
                text: c.client_name,
                value: c.id
            }));

            this.client_options = [{ text: "Select", value: null }, ...options];
        },

        validateState(name) {
            const { $dirty, $error } = this.$v.cms_user_obj[name];
            return $dirty ? !$error : null;
        },

        getErrorMessages(key) {
            let validators = Object.keys(this.$v.cms_user_obj[key].$params);
            let errors = validators
                .filter(v => this.$v.cms_user_obj[key][v] === false)
                .map(v => this.ERROR_MESSAGES[v]);
            return errors;
        },

        async submitAccountForm() {
            this.$v.cms_user_obj.$touch();
            if (this.$v.cms_user_obj.$anyError) {
                return;
            }

            let params = {
                cms_user_obj: this.cms_user_obj,
                user_id: this.$store.state.user_obj.user_id,
                client_id: this.$store.state.user_obj.client_id,
                permission_obj: this.permission_obj
            };

            let req_url = "cms_user_add.php";

            if (this.$route.params.user_id) {
                params.cms_user_id = this.$route.params.user_id;
                req_url = "cms_user_edit.php";
            }

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: req_url,
                data: params
            });

            if (response.data.status === "fail") {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: response.data.error,
                    variant: "danger"
                });
            } else {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: "Update User Success"
                });

                this.$router.go(-1);
            }
        },
        onChangeData: function(data) {
            this.cms_user_obj = data;
        },
        onChangeCheckbox: function(val, id) {
            this.permission_obj[`${id}`].enable = val;
        },
        selectAll: function(e) {
            e.preventDefault();
            console.log(this.permissions);
            for (const key in this.permission_obj) {
                let p = this.permissions;
                p.find(p => p.id === key).enable = 1;
                this.permissions = [...p];
                this.permission_obj[key].enable = 1;
            }
        },
        unselectAll: function(e) {
            e.preventDefault();
            for (const key in this.permission_obj) {
                let p = this.permissions;
                p.find(p => p.id === key).enable = 0;
                this.permissions = [...p];
                this.permission_obj[key].enable = 0;
            }
        },
        loadPermissionGroup() {
            if (!this.permission_group_selected) return;

            let selected_pg = this.permission_groups.find(pg => pg.id === this.permission_group_selected);
            let permissions = selected_pg.permissions;

            let tmp_permission_obj = this.permission_obj;
            Object.keys(tmp_permission_obj).forEach(key => {
                tmp_permission_obj[key].enable = 0;
            })
            permissions.forEach(p => {
                tmp_permission_obj[p.permission_id].enable = 1;
            })

            this.permission_obj = {...tmp_permission_obj};
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.file_document {
    display: none;
}

.preview_img-product {
    max-width: 100%;
    max-height: 200px;
}

.container-preview_img {
    padding: 5px;
}

.icon-add_image {
    color: #cacaca;
}

.col-image {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-group {
    margin-bottom: 0;
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsAccountForm.vue